import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Project } from '../models/Project';
import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';
import { MessagesService } from '../services/messages.service';
import { ExportParameters } from '../models/export/ExportParameters';
import { CryptoService } from '../services/crypto.service';
import { StorageService } from '../services/storageService.service';

const apiUrl = API_SETTINGS.API_URL + 'Export';
const fileApiUrl = API_SETTINGS.API_URL + 'File';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ApiExportService {

  projects: Project[] = [];

  constructor(private http: HttpClient,
    public messageService: MessagesService,
    public cryptoService: CryptoService,
    public storageService: StorageService
    
  ) { }

  async exportProject(id: number, exportParameters: ExportParameters) {
    this.exportProjectRequest(id, exportParameters).subscribe((r) => {
      // console.log(r);
    },
      (error) => {
        window.location.href = error.error.text;
      });
  }

  exportProjectRequest(id: number, exportParameters: ExportParameters): Observable<string> {
    const url = `${apiUrl}/ExportProject/${id}`;
    return this.http.post<string>(url, exportParameters).pipe();
  }

  async exportRationale(id: number) {

    this.messageService.presentLoadingWindow("Downloading Rationale...");
    this.exportRationaleRequest(id).subscribe((r) => {
      //console.log(r);
      this.messageService.loadingWindow.dismiss();
    },
      (error) => {
        var token = error.error.text;
        if (token == undefined) {
          this.messageService.loadingWindow.dismiss();
          this.messageService.presentToast("Rationale failed to download.", "error", "Project");
        }
        else {
          var customerId = +this.cryptoService.decryptData(this.storageService.getItem("customerId"));
          const url = `${fileApiUrl}/${token}/${customerId}`;
          window.location.href = url;
          this.messageService.loadingWindow.dismiss();
        }

      });
  }

  exportXAPIReport(project: Project): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      await this.messageService.presentLoadingWindow("Downloading xAPI...");
      this.exportXAPIRequest(project).subscribe(async (r) => {
        //console.log(r);
        await this.messageService.loadingWindow.dismiss();
        resolve(true);
      },
      async (error) => {
        var token = error.error.text;
        if (token == undefined) {
          await this.messageService.loadingWindow.dismiss();
          this.messageService.presentToast("xAPI failed to download.", "error", "Project");
          resolve(false);
        }
        else {
          var customerId = +this.cryptoService.decryptData(this.storageService.getItem("customerId"));
          const url = `${fileApiUrl}/${token}/${customerId}`;
          window.location.href = url;
          await this.messageService.loadingWindow.dismiss();
          resolve(true);
        }
      });
    });
  }

  exportRationaleRequest(id: number): Observable<string> {
    const url = `${apiUrl}/ExportRationale/${id}`;
    return this.http.get<string>(url).pipe();
  }

  exportXAPIRequest(project: Project): Observable<string> {
    const url = `${apiUrl}/ExportXapiReport/${project.customerId}/${project.projectId}`;
    return this.http.get<string>(url).pipe();
  }

  exportUnpackagedProjectRequest(id: number, exportParameters: ExportParameters): Observable<string> {
    const url = `${apiUrl}/ExportUnpackagedProject/${id}`;
    return this.http.post<string>(url, exportParameters).pipe();
  }

  sendInvitationsToLearnersRequest(id: number, exportParameters: ExportParameters): Observable<string> {
    const url = `${apiUrl}/SendInvitationsToLearners/${id}`;
    return this.http.post<string>(url, exportParameters, httpOptions).pipe();
  }
}

